import { useMemo } from 'react';
import {
  ANY_GENDER_VALUE,
  useDemographicsOptions,
} from '../../../../../../modules/audiences/AudienceForm/components/AudienceCriteria/hooks/useDemographicsOptions';
import type { DemographicsGenderProps } from '../components/expandableSections/demographics/DemographicsGender';

export const useDemographicGender = ({
  selectedGenderSegments,
  setSelectedGenderSegments,
}: DemographicsGenderProps) => {
  const { options } = useDemographicsOptions();

  const handleChange = (id: number) => {
    const selectedSegment = options.genderOptions.filter(segment => genderButtonOptions[id]?.id === segment.id);

    setSelectedGenderSegments(selectedSegment);
  };

  const genderButtonOptions = useMemo(() => {
    const buttons = [{ name: ANY_GENDER_VALUE, id: ANY_GENDER_VALUE }];

    if (options.genderOptions) {
      for (const segment of options.genderOptions) {
        buttons.push({ name: segment.name, id: segment.id });
      }
    }

    return buttons;
  }, [options.genderOptions]);

  const initialSelectedOption = useMemo(() => {
    return selectedGenderSegments.length
      ? genderButtonOptions.findIndex(item => item.id === selectedGenderSegments[0].id)
      : 0;
  }, [selectedGenderSegments, genderButtonOptions]);

  return {
    handleChange,
    initialSelectedOption,
    genderButtonOptions,
  };
};
